import Vue from 'vue'
import Vuex from 'vuex'
import actionForm from '../shared-vue-components/store'
import createLogger from '../utils/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    actionForm
  },
  strict: debug
  // plugins: debug ? [createLogger()] : []
})
